import { render, staticRenderFns } from "./Deactivated.vue?vue&type=template&id=a47c6a18&scoped=true"
import script from "./Deactivated.vue?vue&type=script&lang=js"
export * from "./Deactivated.vue?vue&type=script&lang=js"
import style0 from "./Deactivated.vue?vue&type=style&index=0&id=a47c6a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c6a18",
  null
  
)

export default component.exports